import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useSelectableItem as $8kq0t$useSelectableItem, useSelectableCollection as $8kq0t$useSelectableCollection } from "@react-aria/selection";
import { getFocusableTreeWalker as $8kq0t$getFocusableTreeWalker } from "@react-aria/focus";
import { useState as $8kq0t$useState, useMemo as $8kq0t$useMemo } from "react";
import { useLayoutEffect as $8kq0t$useLayoutEffect, useLabels as $8kq0t$useLabels, mergeProps as $8kq0t$mergeProps, useId as $8kq0t$useId } from "@react-aria/utils";
import { useLocale as $8kq0t$useLocale } from "@react-aria/i18n";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $0175d55c2a017ebc$exports = {};
$parcel$export($0175d55c2a017ebc$exports, "useTab", function () {
  return $0175d55c2a017ebc$export$fdf4756d5b8ef90a;
});
var $99b62ae3ff97ec45$export$c5f62239608282b6 = new WeakMap();

function $99b62ae3ff97ec45$export$567fc7097e064344(state, key, role) {
  if (typeof key === 'string') key = key.replace(/\s+/g, '');
  var baseId = $99b62ae3ff97ec45$export$c5f62239608282b6.get(state);
  return "".concat(baseId, "-").concat(role, "-").concat(key);
}

function $0175d55c2a017ebc$export$fdf4756d5b8ef90a(props, state, ref) {
  var key = props.key,
      propsDisabled = props.isDisabled;
  var manager = state.selectionManager,
      selectedKey = state.selectedKey;
  var isSelected = key === selectedKey;
  var isDisabled = propsDisabled || state.disabledKeys.has(key);

  var _$8kq0t$useSelectable = $8kq0t$useSelectableItem({
    selectionManager: manager,
    key: key,
    ref: ref,
    isDisabled: isDisabled
  }),
      itemProps = _$8kq0t$useSelectable.itemProps;

  var tabId = $99b62ae3ff97ec45$export$567fc7097e064344(state, key, 'tab');
  var tabPanelId = $99b62ae3ff97ec45$export$567fc7097e064344(state, key, 'tabpanel');
  var tabIndex = itemProps.tabIndex;
  return {
    tabProps: _objectSpread(_objectSpread({}, itemProps), {}, {
      id: tabId,
      'aria-selected': isSelected,
      'aria-disabled': isDisabled || undefined,
      'aria-controls': isSelected ? tabPanelId : undefined,
      tabIndex: isDisabled ? undefined : tabIndex,
      role: 'tab'
    })
  };
}

var $34bce698202e07cb$exports = {};
$parcel$export($34bce698202e07cb$exports, "useTabPanel", function () {
  return $34bce698202e07cb$export$fae0121b5afe572d;
});

function $34bce698202e07cb$export$fae0121b5afe572d(props, state, ref) {
  var _$8kq0t$useState = $8kq0t$useState(0),
      _$8kq0t$useState2 = _slicedToArray(_$8kq0t$useState, 2),
      tabIndex = _$8kq0t$useState2[0],
      setTabIndex = _$8kq0t$useState2[1]; // The tabpanel should have tabIndex=0 when there are no tabbable elements within it.
  // Otherwise, tabbing from the focused tab should go directly to the first tabbable element
  // within the tabpanel.


  $8kq0t$useLayoutEffect(function () {
    if (ref === null || ref === void 0 ? void 0 : ref.current) {
      var update = function update() {
        // Detect if there are any tabbable elements and update the tabIndex accordingly.
        var walker = $8kq0t$getFocusableTreeWalker(ref.current, {
          tabbable: true
        });
        setTabIndex(walker.nextNode() ? undefined : 0);
      };

      update(); // Update when new elements are inserted, or the tabIndex/disabled attribute updates.

      var observer = new MutationObserver(update);
      observer.observe(ref.current, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['tabIndex', 'disabled']
      });
      return function () {
        observer.disconnect();
      };
    }
  }, [ref]);
  var id = $99b62ae3ff97ec45$export$567fc7097e064344(state, state === null || state === void 0 ? void 0 : state.selectedKey, 'tabpanel');
  var tabPanelProps = $8kq0t$useLabels(_objectSpread(_objectSpread({}, props), {}, {
    id: id,
    'aria-labelledby': $99b62ae3ff97ec45$export$567fc7097e064344(state, state === null || state === void 0 ? void 0 : state.selectedKey, 'tab')
  }));
  return {
    tabPanelProps: $8kq0t$mergeProps(tabPanelProps, {
      tabIndex: tabIndex,
      role: 'tabpanel',
      'aria-describedby': props['aria-describedby'],
      'aria-details': props['aria-details']
    })
  };
}

var $58d314389b21fa3f$exports = {};
$parcel$export($58d314389b21fa3f$exports, "useTabList", function () {
  return $58d314389b21fa3f$export$773e389e644c5874;
});

var $bfc6f2d60b8a4c40$export$15010ca3c1abe90b = /*#__PURE__*/function () {
  function $bfc6f2d60b8a4c40$export$15010ca3c1abe90b(collection, direction, orientation) {
    var disabledKeys = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Set();

    _classCallCheck(this, $bfc6f2d60b8a4c40$export$15010ca3c1abe90b);

    this.collection = collection;
    this.flipDirection = direction === 'rtl' && orientation === 'horizontal';
    this.orientation = orientation;
    this.disabledKeys = disabledKeys;
  }

  _createClass($bfc6f2d60b8a4c40$export$15010ca3c1abe90b, [{
    key: "getKeyLeftOf",
    value: function getKeyLeftOf(key) {
      if (this.flipDirection) return this.getNextKey(key);else {
        if (this.orientation === 'horizontal') return this.getPreviousKey(key);
        return null;
      }
    }
  }, {
    key: "getKeyRightOf",
    value: function getKeyRightOf(key) {
      if (this.flipDirection) return this.getPreviousKey(key);else {
        if (this.orientation === 'horizontal') return this.getNextKey(key);
        return null;
      }
    }
  }, {
    key: "getKeyAbove",
    value: function getKeyAbove(key) {
      if (this.orientation === 'vertical') return this.getPreviousKey(key);
      return null;
    }
  }, {
    key: "getKeyBelow",
    value: function getKeyBelow(key) {
      if (this.orientation === 'vertical') return this.getNextKey(key);
      return null;
    }
  }, {
    key: "getFirstKey",
    value: function getFirstKey() {
      var key = this.collection.getFirstKey();
      if (this.disabledKeys.has(key)) key = this.getNextKey(key);
      return key;
    }
  }, {
    key: "getLastKey",
    value: function getLastKey() {
      var key = this.collection.getLastKey();
      if (this.disabledKeys.has(key)) key = this.getPreviousKey(key);
      return key;
    }
  }, {
    key: "getNextKey",
    value: function getNextKey(key) {
      do {
        key = this.collection.getKeyAfter(key);
        if (key == null) key = this.collection.getFirstKey();
      } while (this.disabledKeys.has(key));

      return key;
    }
  }, {
    key: "getPreviousKey",
    value: function getPreviousKey(key) {
      do {
        key = this.collection.getKeyBefore(key);
        if (key == null) key = this.collection.getLastKey();
      } while (this.disabledKeys.has(key));

      return key;
    }
  }]);

  return $bfc6f2d60b8a4c40$export$15010ca3c1abe90b;
}();

function $58d314389b21fa3f$export$773e389e644c5874(props, state, ref) {
  var _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$keyboardActiva = props.keyboardActivation,
      keyboardActivation = _props$keyboardActiva === void 0 ? 'automatic' : _props$keyboardActiva;
  var collection = state.collection,
      manager = state.selectionManager,
      disabledKeys = state.disabledKeys;

  var _$8kq0t$useLocale = $8kq0t$useLocale(),
      direction = _$8kq0t$useLocale.direction;

  var delegate = $8kq0t$useMemo(function () {
    return new $bfc6f2d60b8a4c40$export$15010ca3c1abe90b(collection, direction, orientation, disabledKeys);
  }, [collection, disabledKeys, orientation, direction]);

  var _$8kq0t$useSelectable2 = $8kq0t$useSelectableCollection({
    ref: ref,
    selectionManager: manager,
    keyboardDelegate: delegate,
    selectOnFocus: keyboardActivation === 'automatic',
    disallowEmptySelection: true,
    scrollRef: ref
  }),
      collectionProps = _$8kq0t$useSelectable2.collectionProps; // Compute base id for all tabs


  var tabsId = $8kq0t$useId();
  $99b62ae3ff97ec45$export$c5f62239608282b6.set(state, tabsId);
  var tabListLabelProps = $8kq0t$useLabels(_objectSpread(_objectSpread({}, props), {}, {
    id: tabsId
  }));
  return {
    tabListProps: _objectSpread(_objectSpread({}, $8kq0t$mergeProps(collectionProps, tabListLabelProps)), {}, {
      role: 'tablist',
      'aria-orientation': orientation,
      tabIndex: undefined
    })
  };
}

export { $0175d55c2a017ebc$export$fdf4756d5b8ef90a as useTab, $34bce698202e07cb$export$fae0121b5afe572d as useTabPanel, $58d314389b21fa3f$export$773e389e644c5874 as useTabList };